<template>
  <div>
    <div class="container">
      <div class="info-login">
        <div class="header-info">
          <div class="logo">
            <v-img
              :src="logo"
              class="logo-icon"
            ></v-img>
          </div>
        </div>
        <div class="welcome">
          <span class="welcome-text"> {{$t('welcome-text')}}</span>
        </div>
        <div class="info-login-content">
          <p class="white-p">{{$t('esysten')}}</p>
          <p class="white-p">
            {{$t('for-what')}}
          </p>
          <button @click="goToLogin" class="action">{{$t("sign-in")}}</button>
        </div>
        <div class="circle"/>
      </div>

      <div class="form-login">
        <div class="form-login-header">
          <div class="form-login-header-text">
            {{$t("login.unsubscribe_text")}}
          </div>
        </div>
        <div class="form-auth">
          <v-text-field
            v-model="email"
            ref='name'
            :label="$t('login.email')"
            required
            placeholder="synchrotron@nrcki.ru"
            :error="emailError"
          ></v-text-field>
          <v-row>
              <p  class="blue-p">Хочу продолжать получать письма : </p>
          </v-row>
          <v-row>
            <v-checkbox
              class="ma-0"
              v-model="mass_email_on"
              label="Массовые рассылки"
            ></v-checkbox>
          </v-row>
          <v-row>
            <v-checkbox
              class="ma-0"
              v-model="personal_email_on"
              label="Персональные уведомления"
            ></v-checkbox>
          </v-row>

          <div>
            <v-btn
            :loading="preloaderLogin"
            @click="unsubscribe()"
            class="login-button"
            :color="$mainColor">
              {{$t('login.unsubscribe')}}
            </v-btn>
          </div>

        </div>
         <div class="switch switch-login d-flex align-start">
            <h1 class="switch__current-lang">RU</h1>
            <v-switch :color="$mainColor" v-model="changeLanguage" label="EN"></v-switch>
          </div>
      </div>
    </div>

  </div>
</template>

<script>
import logo from '../assets/logo.png';
import { mapActions, mapMutations, mapGetters } from 'vuex';

const reEmail = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;

export default {
  name: 'Unsubscribe',
  beforeMount() {

  },

  data() {
    return {
      email: '',
      personal_email_on: true,
      mass_email_on: false,
      emailError: false,
      logo,
      changeLanguage: '',
      preloaderLogin: false
    };
  },

  mounted() {
      this.SET_APP_LANGUAGE('ru')
      this.$i18n.locale = 'ru'
  },
  watch:{
    changeLanguage(newLang) {
      if (newLang) {
        this.SET_APP_LANGUAGE('en');
        this.$i18n.locale = 'en'
      }
      else {
        this.SET_APP_LANGUAGE('ru')
        this.$i18n.locale = 'ru'
      }
    }
  },

  components: {
  },

  computed: {
  },

  created() {
    this.loading = true;
    localStorage.removeItem('token')
    localStorage.removeItem('isLoggedIn')
  },

  methods: {
    ...mapActions(['LANGUAGE_SWITCH', 'UNSUBSCRIBE']),
    ...mapMutations(['SET_APP_LANGUAGE', 'UPDATE_OVERLAY']),
    goToLogin() {
      this.$router.push('/login');
    },

    async unsubscribe() {
      this.UPDATE_OVERLAY(true)
      this.preloader= true
      this.emailError = false;

      if (reEmail.test(this.email) === false) {
        this.emailError = true;
        this.UPDATE_OVERLAY(false)
        this.preloaderLogin = false
        return
      }

      this.UNSUBSCRIBE({
        email: this.email,
        personal_email_on: this.personal_email_on,
        mass_email_on: this.mass_email_on
      })
      .then((data) => {
          if(data.error){
              this.$messageHelper(data.error, 'error', 3000);
          }
          else{
            this.$messageHelper('Настройки рассылки сохранены', 'success', 15000)
          }
          this.preloaderLogin = false
          this.UPDATE_OVERLAY(false)
      })
      .catch((e) => {
        this.preloaderLogin = false
        this.$messageHelper(`${this.$t('error_occurred')}: ${e.response.data.detail}`, 'error', 3000)
        this.UPDATE_OVERLAY(false)
      });
    },
  },
};
</script>

<style scoped>

.info-login,
.form-login {
  z-index: 1;
}
.container{
  position:absolute;
  top:50%;
  left:50%;
  transform:translate(-50%,-50%);
  display: flex;
  width:1100px;
  height: 550px;
  border-radius:30px;
  z-index: 1;
}
  .info-login{
    text-align: center;
    position: relative;
    padding: 20px;
    width:50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 570px;
    background: #15336d;
    border-top-left-radius: 30px;
    border-bottom-left-radius: 30px;
     -webkit-box-shadow: 0 .46875rem 2.1875rem rgba(4,9,20,.03),0 .9375rem 1.40625rem rgba(4,9,20,.03),0 .25rem .53125rem rgba(4,9,20,.05),0 .125rem .1875rem rgba(4,9,20,.03)!important;
    box-shadow: 0 .46875rem 2.1875rem rgba(4,9,20,.03),0 .9375rem 1.40625rem rgba(4,9,20,.03),0 .25rem .53125rem rgba(4,9,20,.05),0 .125rem .1875rem rgba(4,9,20,.03)!important;
    border-width: 0;
    -webkit-transition: all .2s;
    transition: all .2s;

  }
  .form-login{
    text-align: center;
    background-color: white;
    border-top-right-radius: 30px;
    border-bottom-right-radius: 30px;
    position: relative;
    padding: 20px;
    width:50%;
    justify-content: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 570px;
     -webkit-box-shadow: 0 .46875rem 2.1875rem rgba(4,9,20,.03),0 .9375rem 1.40625rem rgba(4,9,20,.03),0 .25rem .53125rem rgba(4,9,20,.05),0 .125rem .1875rem rgba(4,9,20,.03)!important;
    box-shadow: 0 .46875rem 2.1875rem rgba(4,9,20,.03),0 .9375rem 1.40625rem rgba(4,9,20,.03),0 .25rem .53125rem rgba(4,9,20,.05),0 .125rem .1875rem rgba(4,9,20,.03)!important;
    border-width: 0;
    -webkit-transition: all .2s;
    transition: all .2s;

  }
  .header-info{
    align-items: left;
    display: flex;
    padding-top: 55px;
    justify-content: space-between;

  }
  .logo{
    height: 55px;
    width:55px;
    position: relative;
    border:1px solid white;
    display: flex;
    border-radius: 50%;
  }
  .logo-icon{
      top:50%;
      left:50%;
      transform:translate(-50%,-50%);
      position: absolute;
      height: 37px;
      width:37px;
  }
  .welcome-text{
    font-weight: 1200;
    color: white;
    font-size: 30px ;
    font-weight: lighter;
  }
  .welcome{
    margin-top: 30px;
    margin-bottom: 20px;
  }
  .white-p {
    font-size: 16px ;
    color: white;
    margin:0 0 20px;
  }
  .blue-p {
    font-size: 16px ;
    color: #15336d;
    margin-left: -16px;
  }
  .info-login-content{
    margin: 10px auto;
    width: 320px;
  }
  .info-login-content p{
    line-height: 19px;
  }
  .action{
    margin: 25px auto;
    width:270px;
    padding: 10px;
    background: #15336d;
    color: white;
    border: 1px solid white;
    border-radius:80px;
  }
  .action:hover{
    background: white;
    color: #15336d;
    cursor: pointer;
  }
  .circle{
    border-radius: 100% 0 0 100% / 50% 0 0 50%;
    width: 100px;
    height: 170px;
    background: #15336d;
    border: 20px solid white;
    position: absolute;
    top: 60%;
    left: 85%;
  }
  .form-login-header {
    z-index: 1;
  }
  .form-login-header-text{
    color:#15336d;
    font-size: 25px;
    font-weight: 500;
    margin-bottom: 20px;
  }
  .login-button{
    margin-top:20px;
    background: #15336d;
    color: white;
    border-radius: 60px;
    width: 150px;
    padding: 7px 10px;
  }
.form-login::before {
  content: "";
  position: absolute;
  right: -76px;
  top: 20%;
  width: 150px;
  height: 150px;
  border: 30px solid transparent ;
  border-left: 30px solid #eeeeee;
  border-bottom: 30px solid #eeeeee;
  transform: rotate(45deg);
  border-radius: 30px;
  z-index: 1;}
  .login-lang{
    z-index: 1;
    position: absolute;
    top: 25px;
    left: 54%;
    width: max-content;
  }
  .en{
    background-color: #f8005c;
    color: white;
    margin-left: 0;
    border-radius: 20px;
    padding: 5px 25px 5px 10px;
  }
  .ru{
    padding: 5px 10px;
    border-radius: 20px;
    background-color: #003c72;
    color: #fff;
    margin-left: -20px;
  }

  @media screen and (max-width:959px) {
    .container {
      flex-direction: column;
      align-items: center;
      position: static;
      transform: none;
      width: auto;
      height: auto;
    }
    .circle {
      left: calc(100% - 100px);
    }
    .info-login,
    .form-login {
      width: 85%;
    }
    .info-login {
      border-radius: 0;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
    }
    .form-login {
      border-radius: 0;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
    }
  }
  .form-auth {
    z-index: 1;
  }
</style>
